import Documents from '@/views/Documents/Index.vue'

export default [
    {
        path: '/documents',
        name: 'documents',
        component: Documents,
        meta: {
            title: 'documents.root.pageTitle',
            menuRendered: true,
            menuTitle: 'documents.root.menuTitle',
            permission: ['docs_order'],
            icon: 'mdi-file-document'
        },
        redirect: { name: 'documentsDocuments' },
        children: [
            {
                path: '/documents/documents',
                name: 'documentsDocuments',
                component: () => import('@/views/Documents/Documents/Index.vue'),
                meta: {
                    title: 'documents.list.pageTitle',
                    menuTitle: 'documents.list.menuTitle',
                    requiresAuth: true,
                    permission: ['docs_order_read', 'docs_order_admin_read']
                }
            },
            {
                path: '/documents/documents/create',
                name: 'documentsDocumentsCreate',
                component: () => import('@/views/Documents/Document/Index.vue'),
                meta: {
                    title: 'documents.document.create.pageTitle',
                    requiresAuth: true,
                    permission: ['docs_order_create', 'docs_order_admin_create']
                }
            },
            {
                path: '/documents/documents/:id',
                name: 'documentsDocumentsEdit',
                component: () => import('@/views/Documents/Document/Index.vue'),
                meta: {
                    title: 'documents.document.edit.pageTitle',
                    requiresAuth: true,
                    permission: ['docs_order_update', 'docs_order_admin_update']
                }
            }
        ]
    }
]
